import { deleteRequest } from '../..';

const deleteArea = (LocationId: string) => deleteRequest('locations/areas', { LocationId });

export default deleteArea;
